import { Injectable, EventEmitter } from '@angular/core';
import {
  CdkPortalOutlet,
  TemplatePortal,
  ComponentPortal,
} from '@angular/cdk/portal';

export interface InstructionInfo {
  title?: string;
  icon?: string;
  class?: string;
  linkDSL?: Array<any>;
}

export type BreadcrumbPortal = TemplatePortal<any> | ComponentPortal<any>;

@Injectable()
export class BreadcrumbService {
  onChange: EventEmitter<Array<InstructionInfo>> = new EventEmitter<
    Array<InstructionInfo>
  >();
  onPortalsChange: EventEmitter<Map<string, BreadcrumbPortal>> =
    new EventEmitter<Map<string, BreadcrumbPortal>>();

  private instrs: Array<InstructionInfo>;
  private _portalOutlet: CdkPortalOutlet;
  private _portals: Map<string, BreadcrumbPortal> = new Map();

  get instructions(): Array<InstructionInfo> {
    return this.instrs;
  }

  get portalOutlet(): CdkPortalOutlet {
    return this._portalOutlet;
  }

  get portals(): Map<string, BreadcrumbPortal> {
    return this._portals;
  }

  setPortalOutlet(outlet: CdkPortalOutlet) {
    this._portalOutlet = outlet;
  }

  /**
   * Register a portal with a unique ID. Multiple portals can be registered and will stack left to right.
   * @param id Unique identifier for this portal (typically component name or instance ID)
   * @param portal The TemplatePortal or ComponentPortal to display
   */
  registerPortal(id: string, portal: BreadcrumbPortal): void {
    this._portals.set(id, portal);
    this.onPortalsChange.emit(this._portals);
  }

  /**
   * Unregister a portal by its ID
   * @param id The unique identifier used when registering the portal
   */
  unregisterPortal(id: string): void {
    this._portals.delete(id);
    this.onPortalsChange.emit(this._portals);
  }

  /**
   * Legacy method: Attaches a single portal (for backward compatibility)
   * This will register the portal with a default ID
   * @deprecated Use registerPortal instead for better control
   */
  attachPortal(portal: BreadcrumbPortal): void {
    this.registerPortal('_default', portal);
  }

  /**
   * Legacy method: Detaches the default portal
   * @deprecated Use unregisterPortal instead
   */
  detachPortal(): void {
    this.unregisterPortal('_default');
  }

  update(instructions: Array<InstructionInfo>) {
    this.instrs = instructions;
    this.onChange.next(instructions);
  }
}
